import React from 'react';
import _ from 'lodash';

import { Table, TableRow, TableRowColumn, TableBody, TableHeaderColumn, TableHeader } from 'material-ui/Table';
import {orange500} from 'material-ui/styles/colors';
import NumberField from '../../../Base/NumberField';

const COLUMNS = ['Loaded', 'DWT', 'DWCC', 'Draft', 'Tpc', 'Tpi', 'FreeBoard'];

const PREFIXES = {
    s: 'Summer',
	t: 'Tropical',
	w: 'Winter',
	f: 'Fresh',
	tf: 'Tropical Fresh',
	p: 'Panama',
	ti: 'Timber',
	l: 'Lakes',
	ls: 'Lightship',
	n: 'Nrml Blst Cond',
};

/** @type {Record<string, React.CSSProperties>} */
const styles = {
    underlineStyle: {
      borderColor: orange500,
    },
    headerCol: {
        whiteSpace: 'normal',
        padding: '0 5px',
        wordBreak: 'break-word',
        hyphens: 'auto',
    },
    col: {
        padding: '0 5px',
    },
};

function Deadweight({ confirmed, changeField, getError, deadWeight, dimensions, modifiedFields = [], underStyle = {} }) {
    const textField = (item, index) => {
        return (
            <TableRowColumn key={`${item}${index}`} style={{ ...styles.col, overflow: 'visible' }}>
                <NumberField
                    name={item}
                    floatNumber
                    value={deadWeight[item] || ''}
                    disabled={confirmed}
                    errorText={
                        getError(`deadWeight.${item}`) ||
                        (item === 'sDraft' && 
                            deadWeight.sDraft &&
                            dimensions.depth &&
                            parseInt(deadWeight.sDraft) > parseInt(dimensions.depth) ? 'Draft must be less than depth' : null)
                    }
                    errorStyle={{
                        position: 'absolute',
                        bottom: '-18px',
                        whiteSpace: 'nowrap',
                        backgroundColor: 'white',
                        padding: '4px 6px',
                        borderRadius: '2px',
                        marginTop: '2px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                        border: '1px solid #f44336',
                        zIndex: 100
                    }}
                    onChange={(e, value) => {
                        changeField({
                            field: `deadWeight.${item}`,
                            value,
                        });
                    }}
                    underlineStyle={modifiedFields && modifiedFields.includes(`deadWeight.${item}`) ? underStyle : null}
                    style={{ maxWidth: '50px' }}
                />
            </TableRowColumn>
        );
    };

    return (
        <React.Fragment>
            <Table selectable={false}>
                <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                    <TableRow >
                        <TableHeaderColumn style={{ width: '120px' }} />
                        <TableHeaderColumn style={styles.headerCol}>Loaded displacement</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>DWT, mt</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>DWCC</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>Draft, m</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>Tpc</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>Tpi</TableHeaderColumn>
                        <TableHeaderColumn style={styles.headerCol}>Free-board, m</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                    {Object.entries(PREFIXES).map(([prefix, caption]) => (
                        <TableRow key={prefix}>
                            <TableRowColumn style={{ width: '120px', paddingRight: '0' }}>
                                {caption}
                            </TableRowColumn>
                            {COLUMNS.map((column, index) => textField(prefix + column, index))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </React.Fragment>
    );
}

export default Deadweight;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Deadweight.jsx